import * as _ from 'lodash';

import { Alarm, AlarmList, Dictionary, IValueViewModel } from '../../models/';

export function buildAlarmList(alarmList: AlarmList, viewModels: Dictionary<IValueViewModel>): AlarmList {
    const mapped = {};

    Object
        .keys(alarmList)
        .forEach(g => map(g, alarmList[g], viewModels[g], mapped));

    return mapped;
}

function map(guid: string, alarm: Alarm[], viewModel: IValueViewModel, mapped: {}): void {
    if (alarm?.filter) {
        const filtered = alarm.filter(a => a.isDisabled);
        if (filtered?.length > 0) {
            mapped[guid] = {
                alarms: filtered,
                identifier: viewModel
            };
        }
    }
}